import "./App.css";
import * as React from "react";
import { useDispatch } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { getLocation } from "./actions/location";
import ResetPassword from "./Login/ResetPassword";
import ResetMyPassword from "./user page/ResetPassword";
import { getAllUsers } from "./actions/user";
import Login from "./Login/login";
import InternetConnectionMonitor from "./Internet Connection/InternetConnection";
import { updateUser } from "./actions/user";
import Reconciliation from "./Reconciliation/Reconciliation";
import SingleReconciliation from "./Single Reconciliation/SingleReconciliation";
import Location from "./Location/Location";
import Report from "./Report/Report";
import UpdateReport from "./Report Update/Report";
import VerticalTabs from "./user page/UserAccountPage";
import Approvals from "./Approvals/approvals";
import DeletionRequests from "./Deletions/DeletionRequests";
import Insight from "./Analytics/insight";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import AppLayout from "./ui/AppLayout";
import ProtectedRoute from "./ui/ProtectedRoute";
import secureLocalStorage from "react-secure-storage";
function App() {
  const dispatch = useDispatch();
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  React.useEffect(() => {
    if (user) {
      dispatch(getLocation());
      dispatch(getAllUsers());
    }
  }, [dispatch, user]);

  let allowUpdate = false;
  let allowApprove = false;

  if (
    user?.results.reconciliation === "Approver" ||
    user?.results.reconciliation === "Administrator"
  ) {
    allowApprove = true;
  } else {
    allowApprove = false;
  }

  if (
    user?.results.reconciliation === "Administrator" ||
    user?.results.reconciliation === "Read-Write"
  ) {
    allowUpdate = true;
  } else {
    allowUpdate = false;
  }
  React.useEffect(() => {
    if (user) {
      dispatch(
        updateUser(user?.results._id, {
          login: "yes",
          system: "reconciliation",
        })
      );
    }
  }, [dispatch, user]);
  return (
    <div>
      <HelmetProvider>
        <div className="App">
          <InternetConnectionMonitor />
          <Routes>
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/reconciliation/" element={<Insight />} />
              <Route index element={<Insight />} />
              <Route path="/reconciliation/report" element={<Report />} />
              <Route path="/reconciliation/location" element={<Location />} />
              {allowUpdate && (
                <Route
                  path="/reconciliation/update-report"
                  element={<UpdateReport />}
                />
              )}
              <Route
                path="/reconciliation/new-reconciliation"
                element={<Reconciliation />}
              />
              <Route
                path="/reconciliation/single-reconciliation"
                element={<SingleReconciliation />}
              />
              <Route
                path="/reconciliation/user-page"
                element={<VerticalTabs />}
              />
              {(allowUpdate || allowApprove) && (
                <Route
                  path="/reconciliation/delete-reports"
                  element={<DeletionRequests />}
                />
              )}
              {allowApprove && (
                <Route
                  path="/reconciliation/approvals"
                  element={<Approvals />}
                />
              )}
            </Route>
            <Route
              path="/reconciliation/forgotPassword"
              element={<ResetPassword />}
            />
            <Route
              path="/reconciliation/resetMyPassword/:token"
              element={<ResetMyPassword />}
            />
            <Route path="/reconciliation/login" element={<Login />} />
          </Routes>
          {/* {user && <BottomBar />} */}
        </div>
        <Toaster
          position="top-center"
          gutter={12}
          containerStyle={{ margin: "8px" }}
          toastOptions={{
            success: {
              duration: 3000,
            },
            error: {
              duration: 6000,
            },
            style: {
              fontSize: "14px",
              maxWidth: "500px",
              padding: "10px 20px",
              backgroundColor: "#ffffff",
              color: "#6b7280",
            },
          }}
        />
      </HelmetProvider>
    </div>
  );
}
export default App;
